var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9194 7.50006L7.04445 12.533C3.79445 15.8882 -1.08055 10.8553 2.16945 7.50006L7.04445 2.46716C9.21112 0.230321 12.4611 3.58558 10.2944 5.82243L5.41945 10.8553C4.33612 11.9737 2.71112 10.2961 3.79445 9.17769L8.66945 4.14479",
    stroke: "#115E67",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentPinIcon);
export default __webpack_public_path__ + "static/media/AttachmentPinIcon.6d40312bfe1b97d9905a5f0aff3cb670.svg";
export { ForwardRef as ReactComponent };